import React from 'react';
import {Cart, SignIn} from '.';
import {Context} from '../context';

export default function SideBar(props) {
  const {token} = React.useContext(Context);
  const {className} = props;

  return <div className={`${className}`}>{!token ? <SignIn /> : <Cart />}</div>;
}
